// The per-school subdomain system (`<sub>.bytego.ai`) was removed — every
// school now signs in on this one origin. All that survives here is the
// Control Center host check: `control.<root>` is still a distinct SPA
// surface (App.tsx branches on it before the tenant router even mounts).

// Control Center lives on `control.<root>` (and `control.localhost:<port>`
// in dev — browsers resolve *.localhost to 127.0.0.1, so a developer can
// exercise it without /etc/hosts edits). Returning true here short-circuits
// the per-school router and mounts the dedicated ControlCenterApp instead.
export function isControlCenterHost(hostname = window.location.hostname): boolean {
  const host = hostname.toLowerCase().replace(/:\d+$/, "");
  if (host === "control.localhost") return true;
  return host === "control.bytego.ai" || host === "control.staging.bytego.ai";
}
